import { cn } from '@/lib/utils';
import { StatusType } from '@/types/client';

interface StatusBadgeProps {
  status: StatusType;
  className?: string;
}

const statusConfig: Record<StatusType, { bg: string; text: string; dot: string }> = {
  'Completed': {
    bg: 'bg-success/10',
    text: 'text-success',
    dot: 'bg-success',
  },
  'In Progress': {
    bg: 'bg-info/10',
    text: 'text-info',
    dot: 'bg-info',
  },
  'Pending': {
    bg: 'bg-warning/10',
    text: 'text-warning',
    dot: 'bg-warning',
  },
  'Overdue': {
    bg: 'bg-destructive/10',
    text: 'text-destructive',
    dot: 'bg-destructive',
  },
  'Not Required': {
    bg: 'bg-muted',
    text: 'text-muted-foreground',
    dot: 'bg-muted-foreground',
  },
};

export function StatusBadge({ status, className }: StatusBadgeProps) {
  const config = statusConfig[status];

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-medium',
        config.bg,
        config.text,
        className
      )}
    >
      <span className={cn('w-1.5 h-1.5 rounded-full', config.dot)} />
      {status}
    </span>
  );
}

interface BooleanBadgeProps {
  value: boolean;
  trueLabel?: string;
  falseLabel?: string;
  className?: string;
}

export function BooleanBadge({ 
  value, 
  trueLabel = 'Yes', 
  falseLabel = 'No',
  className 
}: BooleanBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-medium',
        value ? 'bg-success/10 text-success' : 'bg-muted text-muted-foreground',
        className
      )}
    >
      <span className={cn('w-1.5 h-1.5 rounded-full', value ? 'bg-success' : 'bg-muted-foreground')} />
      {value ? trueLabel : falseLabel}
    </span>
  );
}
